import React from 'react'

import Flex from '../../../../../../components/layouts/Flex'
import DashboardInput from '../../../../../../components/dashboard/DashboardInput'
import { CreatableSelectComponent } from '../../../../../../components/SelectDropdown'

import { P } from '../../../../../../style/Typography.style'

const SkillsTestSubmissionReminder = ({
  referralEmail,
  subject,
  testsUrl,
  onChange,
  fieldErrors,
}) => {
  const handleCreatableSelectChanged = (name, e) => {
    const values = e.map((e) => e.value)
    onChange(name, values)
  }

  return (
    <>
      <P marginBottom="0.5rem" weight="500">
        Skills Test Submission Reminder Parameters
      </P>
      <Flex direction="column">
        <DashboardInput
          label="Referral Email"
          placeholder="Enter Referral Email"
          marginBottom="0.5rem"
          value={referralEmail}
          handleChange={(e) =>
            onChange('skills_test_referral_email', e.target.value)
          }
          errorMessage={fieldErrors.skills_test_referral_email}
        ></DashboardInput>
        <DashboardInput
          label="Subject"
          placeholder="Enter Subject"
          marginBottom="0.5rem"
          value={subject}
          handleChange={(e) => onChange('test_subject', e.target.value)}
          errorMessage={fieldErrors.test_subject}
        ></DashboardInput>
        <CreatableSelectComponent
          noOption
          id="tests_url"
          title="Link of Tests"
          selected={testsUrl}
          onChange={(e) => handleCreatableSelectChanged('tests_url', e)}
          placeholder="Type something and press enter..."
          wrapperClass={fieldErrors.tests_url && 'error'}
          subText={fieldErrors.tests_url}
        />
      </Flex>
    </>
  )
}

export default SkillsTestSubmissionReminder
